import { useEffect, useState } from 'react';
import {
  useGetHighestTransactions,
  useQueryData,
  GetTransactionsResponse,
  MonthYearInput,
  DEFAULT_OVERRIDE_CACHE_TIME,
} from '@ecolytiq/js-data-provider';

import { Transactions } from 'impactApp/modules/HomePage';
import { useDeps } from 'App/context';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'impactApp/routes/routePaths';

export const useHighestTransactionsListData = (month: MonthYearInput) => {
  const { httpClientService } = useDeps();

  const [response, setResponse] = useState<Omit<Transactions, 'isLoading'>>({
    transactions: [],
  });
  const { transactions } = response;
  const navigate = useNavigate();
  const { SSO_PAGE } = RoutePaths;

  const { isLoading, isFetching, data, isError, error } = useQueryData<{ data: GetTransactionsResponse }>(
    useGetHighestTransactions(httpClientService, month),
    {
      staleTime: DEFAULT_OVERRIDE_CACHE_TIME,
      cacheTime: 0,
    }
  );

  useEffect(() => {
    if (data?.data.transactions) {
      setResponse({
        transactions: data.data.transactions.results,
      });
    } else if (!isLoading && !data) {
      navigate(SSO_PAGE);
    }
  }, [data, setResponse, navigate, SSO_PAGE, isError, error, isLoading]);

  return {
    isLoading: isLoading || isFetching,
    transactions,
  };
};
